import React, { useContext } from 'react';

import { Tooltip } from '@material-ui/core';
import { NavLink } from 'react-router-dom';

import { AuthContext } from '@/core/auth/AuthContext';
import { UserList } from '@/core/users/UserManagement/UserList';
import { UsersNavigationBar } from '@/core/users/UsersNavigationBar';
import { ReactComponent as AddUsersIcon } from '@/icons/add_users.svg';
import { ReactComponent as UserVoiceLogo } from '@/icons/uservoice_logo_dark.svg';
import routes from '@/routes';

export function UserManagement () {
  const { currentUser, hasCoreAccess, hasUvkAccess } = useContext(AuthContext);
  let canInvite = (hasCoreAccess && currentUser?.coreOwner) || (hasUvkAccess && currentUser?.uvkAdmin);

  const enabledClasses = 'text-gray-100 bg-blue-900';
  const disabledClasses = 'text-gray-600 bg-gray-200';

  return (
    <>
      <div className="sticky top-0 z-10 shadow-soft">
        <UsersNavigationBar>
          <UserVoiceLogo className="w-32 ml-8" />
        </UsersNavigationBar>
      </div>
      <main className="p-16 mx-auto" style={{ width: 1200 }}>
        <div className="flex justify-between mb-10">
          <h1 className="font-serif text-5xl font-bold text-blue-900">
            User roles and access
          </h1>
          <Tooltip title={canInvite ? '' : 'You do not have permission to invite new administrators. Please contact your account owner for assistance.'}>
            <NavLink
              to={routes.users.invite}
              className={`${canInvite ? enabledClasses : disabledClasses} flex items-center px-4 font-medium rounded`}
              onClick={(evt) => {
                if (!canInvite) {
                  evt.preventDefault();
                }
              }}
            >
              <AddUsersIcon className="w-6 h-3 mr-2" />
              Add team member
            </NavLink>
          </Tooltip>
        </div>
        <UserList />
      </main>
    </>
  );
}
